import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useInsurance() {
    const api = useApi();
    const state = useAppState();
    function getInsuranceInfo(onSuccess = null, refreshCache = false) {
        const config = getApiConfig();
        const uri = config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Policies";
        if (refreshCache) {
            localStorage.removeItem(uri);
            return;
        }
        api.GET(uri, (result) => {
            state.insuranceInfo = result;
            if (onSuccess)
                onSuccess();
        }, !refreshCache, refreshCache);
    }
    function getInsuranceProviders(onSuccess = null) {
        api.GET("/InsuranceProviders", (result) => {
            state.insuranceProviders = result;
            if (onSuccess)
                onSuccess(result);
        });
    }
    function getPolicyTypes(onSuccess = null) {
        api.GET("/PolicyTypes", (result) => {
            state.policyTypes = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getPolicy(policyId, onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policyId, (result) => {
            state.policy = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function addPolicy(policy, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Policies", policy)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addPolicy(policy, onSuccess));
            }
        });
    }
    function updatePolicy(policy, onSuccess = null) {
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policy.id, policy)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updatePolicy(policy, onSuccess));
            }
        });
    }
    function deletePolicy(policyId, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Policies/" + policyId)
            .then(() => { if (onSuccess)
            onSuccess(); });
    }
    return {
        getInsuranceInfo,
        getInsuranceProviders,
        getPolicyTypes,
        getPolicy,
        addPolicy,
        updatePolicy,
        deletePolicy,
    };
}
